import { useState } from 'react';
import enhancementPackages from '../helpers/enhancementPackages';
import { useAuth } from '../hooks/useAuth';
import { currency } from '../utils';
import { calculateEnhancementPackageRate } from '../helpers/pricing';
import { useQuery } from '@apollo/client';
import { DEFAULT_ENHANCEMENT_PACKAGES_QUERY } from '../queries/packageQueries';

export default function EnhancementPackageDetailsDisplay({ packageName }) {
  const { user } = useAuth();
  const { plan } = user;

  const enhancementPackage = enhancementPackages.find(
    ({ packageName: enhancementPackageName }) =>
      enhancementPackageName === packageName
  );
  const { variablesIncluded, rate, additionalDescription } =
    enhancementPackage || {};

  // Try to fetch backend-defined variables for this package name
  const { data: defPkgsData } = useQuery(DEFAULT_ENHANCEMENT_PACKAGES_QUERY, {
    fetchPolicy: 'cache-first',
  });
  const defaultPkgs = defPkgsData?.defaultEnhancementPackages || [];
  const aliasMap = { Foundation: 'Foundations' };
  const target = aliasMap[packageName] || packageName;
  const backendVars = defaultPkgs?.find((p: any) => p?.packageName === target)?.variablesIncluded;
  const effectiveVariables = backendVars ?? variablesIncluded;

  const [expanded, setExpanded] = useState(false);
  const MAX_VISIBLE = 20;
  const isArray = Array.isArray(effectiveVariables);
  const showToggle = isArray && (effectiveVariables as any[])?.length > MAX_VISIBLE;
  const itemsToRender = isArray
    ? (expanded
        ? (effectiveVariables as any[])
        : (effectiveVariables as any[]).slice(0, MAX_VISIBLE))
    : [];

  return (
    <div className="flex flex-col">
      <p className="mb-2">
        Enhancement Package Selected:{' '}
        <span className="font-bold">{packageName}</span>
      </p>

      <p>
        Price / record:{' '}
        <span className="font-bold">
          {currency(calculateEnhancementPackageRate(rate, plan), 2, 4)}
        </span>
      </p>
      {effectiveVariables && (
        <>
          <div>
            <p className="font-bold mb-2 mt-4">Elements Included:</p>

            {typeof effectiveVariables === 'string' && (
              <p>{effectiveVariables}</p>
            )}
            {Array.isArray(effectiveVariables) && (
              <div className="pl-5 mb-6">
                <ul className="list-disc">
                  {itemsToRender?.map((variable: any) => (
                    <li key={typeof variable === 'string' ? variable : JSON.stringify(variable)}>
                      {typeof variable === 'string' ? variable : (variable?.name || '')}
                    </li>
                  ))}
                </ul>
                {showToggle && (
                  <button
                    type="button"
                    className="mt-2 text-blue-600 hover:text-primary underline"
                    onClick={() => setExpanded((v) => !v)}
                  >
                    {expanded ? 'See less' : `See all (${(effectiveVariables as any[]).length - MAX_VISIBLE} more)`}
                  </button>
                )}
              </div>
            )}
          </div>
        </>
      )}
      {additionalDescription && <>{additionalDescription}</>}
    </div>
  );
}
